'use client'

import { SessionProvider } from 'next-auth/react'
import { ToastProvider } from '@/components/ui/toast'
import { TooltipProvider } from '@/components/ui/tooltip'

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider
      basePath={`${process.env.NEXT_PUBLIC_BASE_PATH || ''}/api/auth`}
      // Refetch session every 4 minutes to keep tokens fresh
      // This triggers the JWT callback which handles token refresh
      refetchInterval={4 * 60}
      // Also refetch when user returns to the tab
      refetchOnWindowFocus={true}
    >
      {/* One tooltip provider for the rail, SourceHint and every other tooltip. */}
      <TooltipProvider delayDuration={300}>
        {children}
        <ToastProvider />
      </TooltipProvider>
    </SessionProvider>
  )
}
